import { render } from "./RequestToReceiveView.vue?vue&type=template&id=3e536270"
import script from "./RequestToReceiveView.vue?vue&type=script&lang=js"
export * from "./RequestToReceiveView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__